import { render, staticRenderFns } from "./Profession.vue?vue&type=template&id=46e6b8b9"
import script from "./Profession.vue?vue&type=script&lang=js"
export * from "./Profession.vue?vue&type=script&lang=js"
import style0 from "./Profession.vue?vue&type=style&index=0&id=46e6b8b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports